function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import React, { forwardRef } from 'react';
import { OverlayTrigger } from 'react-bootstrap';
/*
This component is mainly to be used with custom overlays
to avoid injecting refs. For other scenarios we should use the 
included Tooltip, Popover from react-bootstrap
*/ var HoverableOverlay = function(props) {
    var overlay = props.overlay, children = props.children, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, asPopover = props.asPopover, rest = _object_without_properties(props, [
        "overlay",
        "children",
        "onMouseEnter",
        "onMouseLeave",
        "asPopover"
    ]);
    var OverlayContainer = function() {
        var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _$props, ref = arguments.length > 1 ? arguments[1] : void 0;
        var placement = _param.placement, scheduleUpdate = _param.scheduleUpdate, arrowProps = _param.arrowProps, outOfBoundaries = _param.outOfBoundaries, show = _param.show, _$props = _object_without_properties(_param, [
            "placement",
            "scheduleUpdate",
            "arrowProps",
            "outOfBoundaries",
            "show"
        ]);
        return /*#__PURE__*/ React.createElement("div", _object_spread({
            ref: ref,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave
        }, _$props), /*#__PURE__*/ React.cloneElement(overlay, _$props));
    };
    var OverlayContainerWithRef = /*#__PURE__*/ forwardRef(OverlayContainer);
    return /*#__PURE__*/ React.createElement(OverlayTrigger, _object_spread({
        overlay: asPopover ? overlay : /*#__PURE__*/ React.createElement(OverlayContainerWithRef, null)
    }, rest), children);
};
export default HoverableOverlay;
